import { useQuery } from '@tanstack/react-query';

import { api } from '../../shared/api/client';
import { queryKeys } from '../../shared/api/queryKeys';

export type PracticesFilters = {
  teacher?: string;
  from?: string;
  to?: string;
  status?: string;
};

/** Пустые фильтры не уходят в запрос: для API «нет параметра» и `teacher=` — не одно и то же. */
function query(filters: PracticesFilters, cursor: string | undefined) {
  const params: Record<string, string> = {};
  if (filters.teacher) params.teacher = filters.teacher;
  if (filters.from) params.from = filters.from;
  if (filters.to) params.to = filters.to;
  if (filters.status) params.status = filters.status;
  if (cursor) params.cursor = cursor;
  return params;
}

/** Страница практик всех учителей (CAP-5). Ключ несёт фильтры и курсор — своя страница на каждый. */
export function usePracticesList(filters: PracticesFilters, cursor: string | undefined) {
  const params = query(filters, cursor);
  return useQuery({
    queryKey: queryKeys.practices.list(params),
    queryFn: () => api.get('/admin/practices', { params: { query: params } }),
    placeholderData: (previous) => previous,
  });
}

/** Страница росписи практики (CAP-6): подтверждённые записи, по курсору. */
export function usePracticeRoster(practiceId: string, cursor: string | undefined) {
  const params: Record<string, string> = cursor ? { cursor } : {};
  return useQuery({
    queryKey: queryKeys.practices.roster(practiceId, params),
    queryFn: () =>
      api.get('/admin/practices/{id}/bookings', {
        params: { path: { id: practiceId }, query: params },
      }),
    placeholderData: (previous) => previous,
  });
}
